import runtimeEnv from "@mars/heroku-js-runtime-env";
const env = runtimeEnv();

declare global {
  interface Window {
    env: { [key: string]: string };
  }
}

export const config = () => ({
  env: (varname: string): string | undefined => {
    return (window.env && window.env[varname]) || env[varname];
  },
});
